// extracted by mini-css-extract-plugin
module.exports = {"header":"notifies-list__header___8KDoS","list":"notifies-list__list___2iewj"};